import html from './about.html';
import {partial} from '../../../utils/partial';
import Mustache from 'mustache';

import {Flag} from '../../components/flag/flag';
import {Header} from '../../components/header/header';
import {Footer} from '../../components/footer/footer';
import {contentContainer, phoneBoundary, getLanguage} from '../../../configs/global';
import data from '../../../configs/about.ts';
import {TweenMax} from 'gsap';
import {emitter, EVENTS} from '../../../utils/emitter';
import {Window} from '../../../utils/controllers/window';

//state--inverted

export class About {
  public element: HTMLElement;
  private flag: Flag;
  private header: Header;
  private footer: Footer;

  constructor(flag: Flag, header: Header, footer: Footer) {
    this.element = partial(Mustache.render(html, data[getLanguage()]), 'section');
    this.flag = flag;
    this.header = header;
    this.footer = footer;
    this.render();

    this.presetAnimation();

    this.addHandlers();

    this.onResize();
    this.header.changeBackgroundTransparency(0);
  }

  private addHandlers() {
    this.element.addEventListener('scroll', this.onScroll);
    emitter.on(EVENTS.resize, this.onResize);
  }

  private onResize = () => {
    this.onScroll();
  };

  private onScroll = () => {
    const scrollTop = this.element.scrollTop;
    const bottomThreshold = this.element.querySelector('.wrapper').clientHeight - Window.height;

    // Header scroll handler
    this.header.onScroll(scrollTop, bottomThreshold);
  };

  private render() {
    const parent = document.querySelector(contentContainer);
    parent.appendChild(this.element);
  }

  // -- Events

  // -- Animations
  public animateIn(delay = 0) {
    this.presetAnimation();

    this.header.animateIn();
    this.footer.animateIn();
    this.header.animateToWhite();
    this.footer.animateToWhite();

    this.header.aboutLinkActive(true);

    this.flag.animateInDarkBackground();

    TweenMax.to(this.element, 0.5, {opacity: 1, delay: delay + 1});
  }

  public async animateOut(delay = 0) {
    this.header.aboutLinkActive(false);

    this.header.animateToBlack();
    this.footer.animateToBlack();
    TweenMax.to(this.element, 0.7, {opacity: 0, delay});
    await this.flag.animateOutDarkBackground(delay);
  }

  private presetAnimation() {
    TweenMax.set(this.element, {opacity: 0});
  }

  public kill() {
    this.element.remove();
  }

  public resize() {}
}
